export interface FrontResponse {
  sucesso: boolean;
  codigo?: number;
  mensagem?: string;
  mensagens?: string[];
  traceId?: string;
  raw?: any;
}

/**
 * Interpreta os diferentes formatos de resposta/erro do backend
 * e devolve um objeto padronizado para o front.
 *
 * NÃO altera o fluxo de chamada — apenas facilita ler mensagem/código.
 */
export function parseBackendResponse(body: any, status: number): FrontResponse {
  const result: FrontResponse = {
    sucesso: status >= 200 && status < 300,
    codigo: status,
    raw: body
  };

  if (!body) {
    if (!result.sucesso) {
      result.mensagem = 'Ocorreu um erro ao processar a requisição.';
    }
    return result;
  }

  const isObject = typeof body === 'object';

  // 1) Global middleware de erro: { sucesso, codigo, mensagem, traceId }
  if (
    isObject &&
    'sucesso' in body &&
    'codigo' in body &&
    'mensagem' in body
  ) {
    result.sucesso = !!body.sucesso;
    result.codigo = body.codigo;
    result.mensagem = body.mensagem;
    if (body.traceId) {
      result.traceId = body.traceId;
    }
    return result;
  }

  // 2) MensagemDto: { codigo, listaMensagem }
  if (
    isObject &&
    'codigo' in body &&
    'listaMensagem' in body &&
    Array.isArray((body as any).listaMensagem)
  ) {
    result.codigo = body.codigo;
    result.mensagens = body.listaMensagem;
    result.mensagem = body.listaMensagem[0] || undefined;
    return result;
  }

  // 3) Objeto com Codigo/Mensagem/Sucesso (ex.: redefinição de senha)
  if (
    isObject &&
    (('Codigo' in body || 'codigo' in body) &&
      ('Mensagem' in body || 'mensagem' in body))
  ) {
    const codigo = (body as any).Codigo ?? (body as any).codigo;
    const mensagem = (body as any).Mensagem ?? (body as any).mensagem;
    const sucesso = (body as any).Sucesso ?? (body as any).sucesso;

    result.codigo = typeof codigo === 'number' ? codigo : status;
    result.mensagem = mensagem;

    if (typeof sucesso === 'boolean') {
      result.sucesso = sucesso;
    }

    if ((body as any).traceId) {
      result.traceId = (body as any).traceId;
    }

    return result;
  }

  // 4) Objeto simples com { mensagem } ou { message }
  if (isObject && ('mensagem' in body || 'message' in body)) {
    result.mensagem = (body as any).mensagem ?? (body as any).message;
    return result;
  }

  // 5) Body string puro (ex.: 404 retornando só texto)
  if (typeof body === 'string') {
    result.mensagem = body;
    return result;
  }

  // 6) Resposta de dados (DTO/objeto qualquer)
  if (!result.sucesso) {
    result.mensagem = 'Ocorreu um erro ao processar a requisição.';
  }

  return result;
}


